import { createApi } from '@reduxjs/toolkit/query/react';
import { encodeParam } from './loginApi';
import { AccountCreateRequest, RedirectResponse } from '../types';
import baseQuery from './fetchBaseQuery';

const api = createApi({
    reducerPath: 'createAccountApi',
    baseQuery,
    endpoints: build => ({
        createAccount: build.mutation<RedirectResponse, AccountCreateRequest & { next?: string }>({
            query: ({ username, password, consentRequest, next }) => ({
                url: `/create/api?next=${encodeParam(next)}`,
                method: 'POST',
                body: {
                    username,
                    password,
                    consentRequest,
                },
            }),
        }),
    }),
});
export const { useCreateAccountMutation } = api;
export default api;
